import { produce } from 'immer';

import { ShowUploadFileImportWizardRequestError } from '../../actions/importWizard/showUploadFileImportWizardRequestError';
import { mapTextToErrors } from '../../service/ErrorsMapper/ErrorsMapper';
import { importFileUploadErrorMapper } from '../../service/ImportHelpers/ErrorsTextMapper/ErrorsTextMapper';
import { ImportWizardState } from '../../typings/importWizard';

export function showUploadFileImportWizardRequestError(
    state: ImportWizardState,
    action: ShowUploadFileImportWizardRequestError
): ImportWizardState {
    return produce(state, draft => {
        const errors = action.errors.length > 0 ? action.errors : [{ code: '', params: null, path: '' }];

        draft.errors = mapTextToErrors(errors, importFileUploadErrorMapper).map<string>(({ text }) =>
            typeof text === 'string' ? text : ''
        );
    });
}
